import { Component, OnInit, Inject } from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';
import { ClozeTestModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-model';
import { ClozeTestStyleModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-style-model';
import { UrlParametersModel } from 'gast-onset-ng/lib/cloze-test/model/url-parameters-model';
import { IdasService } from 'src/shared/services/idas/idas.service';
import { OnsetExamResultDto } from 'src/shared/dtos/onset-exam-result-dto';

import { ActivatedRoute } from '@angular/router';
import { ConnectorAuthService } from 'src/shared/services/common/connector-auth.service';

@Component({
  selector: 'app-idas-onset',
  templateUrl: './idas-onset.component.html',
  styleUrls: ['./idas-onset.component.css']
})
export class IdasOnsetComponent implements OnInit {

  isMobile: boolean;

  environment;
  gastBookingId: number;

  // TODO: replace with parameter
  startLevel = 2;
  endLevel = 5;
  variantId = 11;
  language = 1; // default DE
  lang = 'de';

  clozeTestModel: ClozeTestModel;
  clozeTestStyleModel: ClozeTestStyleModel;

  constructor(@Inject('env') private envConfig: any, private deviceService: DeviceDetectorService,
    private idasService: IdasService, private authService: ConnectorAuthService, private route: ActivatedRoute) {
    this.environment = this.envConfig.callback(this.envConfig.value);
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    this.gastBookingId = null;

    this.route.queryParams.subscribe(params => {
      if (params['lang'] === 'en') {
        this.language = 2;
        this.lang = 'en';
      }
      this.clozeTestModel = this.generateClozeTestModel();
      this.clozeTestStyleModel = this.generateClozeTestStyle();
    });
  }

  public onStartTest(start: boolean): void {
    console.log(`test started`);
  }

  public onBookingInit(gastBookingId: number): void {
    this.gastBookingId = gastBookingId;
    console.log(`init gastBookingId ${gastBookingId}`);
  }

  public onTestHasBeenSaved(gastBookingId: number): void {
    this.gastBookingId = gastBookingId;
    console.log(`saving gastBookingId ${gastBookingId}`);
  }

  public onClozeTestCompleted(): void {
    console.log(`test completed`);
  }

  public onTestResult(test: any): void {
    // build result dto
    const onsetExamResultDto: OnsetExamResultDto = new OnsetExamResultDto;
    onsetExamResultDto.bookingId = this.gastBookingId;
    onsetExamResultDto.variantId = this.variantId;
    onsetExamResultDto.startLevel = this.startLevel;
    onsetExamResultDto.endLevel = this.endLevel;

    // retrieve token
    const token = this.authService.onsetExamDataDto.value.token;

    this.idasService.postOnsetExamResult(token, onsetExamResultDto);
    console.log(`next test result ${test}`);
  }

  /* tslint:disable:max-line-length */
  private generateClozeTestModel(): ClozeTestModel {

    // const onsetServiceUrl = this.environment.onsetServiceUrl;
    // const onsetServiceUrl = 'http://gast-appr-app-2:8008/gast-service-onset/';
    const onsetServiceUrl = 'https://apprex.gast.de/gast-service-onset/';

    // TODO config
    const clozeTestModel: ClozeTestModel = {} as ClozeTestModel;
    clozeTestModel.getResultsUrl = onsetServiceUrl + 'api/score';
    clozeTestModel.postTestUrl = onsetServiceUrl + 'api/aufgabe/save';
    clozeTestModel.getTestUrl = onsetServiceUrl + 'api/aufgabe';
    clozeTestModel.getNextTestUrl = onsetServiceUrl + 'api/aufgabe/next';
    clozeTestModel.startWithBuchungId = this.gastBookingId;
    clozeTestModel.urlParameters = { herkunft: 'deutschland', geschlecht: 'm', geburtsdatum: '1990-01-01', variante: this.variantId, testzentrum: 454, sprache: this.language, tool: 1, start_level: this.startLevel, end_level: this.endLevel } as UrlParametersModel;
    return clozeTestModel;
  }

  private generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'http://www.wikipedia.com/';

    return model;
  }
}
